export default class DetailSpec {
    getId() {
        throw new Error("method must be overriden by subclasses.");
    }

    getMapBundleId() {
        throw new Error("method must be overriden by subclasses.");
    }

    getName() {
        throw new Error("method must be overriden by subclasses.");
    }

    getSummary() {
        throw new Error("method must be overriden by subclasses.");
    }

    getDescription() {
        throw new Error("method must be overriden by subclasses.");
    }

    isCoordinatesVisible() {
        throw new Error("method must be overriden by subclasses.");
    }

    isLinkToGoogleMapsVisible() {
        throw new Error("method must be overriden by subclasses.");
    }

    getCoordinates() {
        throw new Error("method must be overriden by subclasses.");
    }

    getLinkToGoogleMaps() {
        throw new Error("method must be overriden by subclasses.");
    }

    getHeaderIconUrl() {
        throw new Error("method must be overriden by subclasses.");
    }
}